import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import taggingEnvironment from '../../lib/utils/tagging-environments';
import { HeaderSections } from './lib/header-sections';

import * as styles from './index.module.scss';

export const Header = () => {
  const [menuState, setMenuState] = useState(false);

  const data = useStaticQuery(graphql`
    query { 
      allContentfulMenus {
        nodes {
          metadata {
            tags {
              name
            }
          }
          menuItems {
            id
            template
            title
            url
            displayAsFeaturedLink
            featuredBlock {
              ...BannerCardFields
            }
            displayAsSectionTitle
            subMenu {
              title
              displayAsFeaturedLink
              image {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: [AVIF, WEBP, AUTO]
                )
              }
              description
              id
              url
              featuredBlock {
                ...BannerCardFields
              }
              displayAsSectionTitle
              subMenu {
                title
                description
                id
                url
                description
                 displayAsFeaturedLink
                image {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: BLURRED
                    formats: [AVIF, WEBP, AUTO]
                  )
                }
                featuredBlock {
                  ...BannerCardFields
                }
                displayAsSectionTitle
              }
            }
          }
        }
      }
    }        
  `);

  const validMenus = data.allContentfulMenus.nodes.filter(node => 
    taggingEnvironment.checkEnvironment(node.metadata.tags)
  );

  const menus = validMenus.find(node => 
    node.metadata?.tags?.some(tag => tag.name === taggingEnvironment.stagingContentfulTag)
  ) || validMenus[0];

  return (
    <header 
      className={`${styles.header} ${menuState && styles.open}`}
    >
      <HeaderSections data={menus} menuState={menuState} setMenuState={setMenuState} />
    </header>
  )
}